import React, { useState } from 'react';
import { 
  Server, 
  Wifi, 
  Shield, 
  Settings, 
  Activity,
  X 
} from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
import { itSupportData } from '../../data/itSupportData';

const SystemStatusButton = () => {
  const [isOpen, setIsOpen] = useState(false);
  const { systemStatus } = itSupportData.stats;

  return (
    <div className="fixed bottom-6 right-6 z-50">
      <AnimatePresence>
        {isOpen && (
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: 20 }}
            className="absolute bottom-16 right-0 bg-white rounded-xl shadow-lg border border-gray-200 w-80"
          >
            <div className="p-4 border-b border-gray-100">
              <h3 className="font-semibold text-gray-900">System Status</h3>
            </div>
            <div className="p-4 space-y-4">
              {Object.entries(systemStatus).map(([key, value]) => (
                <div key={key} className="flex items-center justify-between">
                  <div className="flex items-center gap-3">
                    {key === 'servers' && <Server className="w-4 h-4 text-gray-400" />}
                    {key === 'network' && <Wifi className="w-4 h-4 text-gray-400" />}
                    {key === 'security' && <Shield className="w-4 h-4 text-gray-400" />}
                    {key === 'services' && <Settings className="w-4 h-4 text-gray-400" />}
                    <span className="capitalize text-sm text-gray-700">{key}</span>
                  </div>
                  <div className="flex items-center gap-2">
                    <div className={`w-2 h-2 rounded-full ${
                      value.status === 'operational' ? 'bg-green-400' :
                      value.status === 'partial' ? 'bg-yellow-400' :
                      'bg-red-400'
                    }`} />
                    <span className="text-sm text-gray-500">
                      {value.uptime || value.lastIncident || (value.affectedServices?.join(', '))}
                    </span>
                  </div>
                </div>
              ))}
            </div>
          </motion.div>
        )}
      </AnimatePresence>
      <button
        onClick={() => setIsOpen(!isOpen)}
        className={`p-3 rounded-full shadow-lg flex items-center gap-2 transition-all ${
          isOpen ? 'bg-gray-900 text-white' : 'bg-white text-gray-900 hover:bg-gray-50'
        }`}
      >
        {isOpen ? (
          <X className="w-5 h-5" />
        ) : (
          <Activity className="w-5 h-5" />
        )}
      </button>
    </div>
  );
};

export default SystemStatusButton; 